import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { AuthService } from 'src/services/auth.service';

@Component({
  standalone: true,
  imports: [CommonModule, IonicModule, RouterModule],
  selector: 'app-portals-layout',
  templateUrl: './portals-layout.component.html',
  styleUrls: ['./portals-layout.component.scss'],
})
export class PortalsBaseLayoutComponent {
  constructor(
    public router: Router,
    public authService: AuthService,
  ) {}
}
